import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { toErrorId, toErrorMessage } from '@atlassian/jira-project-settings-apps-common/src/types';
import { famaCatchAndLogFetchError } from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error';
import { PACKAGE_NAME } from '../../model/constants';
import type { ProjectContext } from './types';

/**
 * returns the end point for delete a project
 */
export const getDeleteProjectEndpoint = (context: ProjectContext): string =>
	`${context.baseUrl}/rest/api/2/project/${String(context.projectId)}`;

const deleteProject = (context: ProjectContext): Promise<void> =>
	famaCatchAndLogFetchError(
		performDeleteRequest(getDeleteProjectEndpoint(context)),
		PACKAGE_NAME,
		toErrorId('deleteProject'),
		toErrorMessage('Failed to delete a project'),
	);

export default deleteProject;
